export function ErrorMessage({ message }: { message: string }) {
  return message ? (
    <p className="text-danger-foreground mt-2 text-center" role="alert">
      {message}
    </p>
  ) : null;
}
